const reportType = {
    financial: {
        value: 'financial',
        title: 'Financial Report',
        csv: '/templates/FinancialReportTemplate.csv',
    },
    market: {
        value: 'market',
        title: 'Market Report',
        csv: '/templates/MarketReportTemplate.csv',
    },
    company: {
        value: 'company',
        title: 'Company Report',
        csv: '/templates/CompanyReportTemplate.csv',
    },
    valuation: {
        value: 'valuation',
        title: 'Valuation Report',
        csv: '/templates/ValuationReportTemplate.csv',
    }
};

const marketReportInputs = {

    businessRevenue: {
        type: 'number',
        section: 'income_statement',
        label: 'Annual Sales'
    },
    employment: {
        type: 'number',
        section: 'employment',
        label: 'Employees'
    },
    averageAnnualWage: {
        type: 'number',
        section: 'employment',
        label: 'Average Annual Wage'
    },
    rent: {
        type: 'number',
        section: 'income_statement',
        label: 'Rent'
    }
};

const financialReportInputs = {
    businessRevenue: {
        type: 'number',
        section: 'income_statement',
        label: 'Business Revenue*'
    },
    costOfSalesLaborPortion: {
        type: 'number',
        section: 'income_statement',
        label: 'Cost of Sales - Labor Portion'
    },
    grossMargin: {
        type: 'number',
        section: 'income_statement',
        label: 'Gross Margin*'
    },
    officersComp: {
        type: 'number',
        section: 'income_statement',
        label: 'Officers Compensation'
    },
    incomeExpenseAddbacks: {
        type: 'number',
        section: 'income_statement',
        label: '1x Expense Addbacks'
    },
    ownerReplacementCompensation: {
        type: 'number',
        section: 'income_statement',
        label: 'Owner Replacement Compensation'
    },
    salaryWages: {
        type: 'number',
        section: 'income_statement',
        label: 'Salary-Wages'
    },
    rent: {
        type: 'number',
        section: 'income_statement',
        label: 'Rent'
    },
    taxesPaid: {
        type: 'number',
        section: 'income_statement',
        label: 'Taxes Paid'
    },
    advertising: {
        type: 'number',
        section: 'income_statement',
        label: 'Advertising'
    },
    benefitsPension: {
        type: 'number',
        section: 'income_statement',
        label: 'Benefits-Pensions'
    },
    repairs: {
        type: 'number',
        section: 'income_statement',
        label: 'Repairs'
    },
    badDebt: {
        type: 'number',
        section: 'income_statement',
        label: 'Bad Debt'
    },
    salesGeneralAdminMisc: {
        type: 'number',
        section: 'income_statement',
        label: 'Sales, General, Admin & Misc.'
    },
    amortizationDepreciationDepletion: {
        type: 'number',
        section: 'income_statement',
        label: 'Amortization Depreciation Depletion'
    },
    interestIncome: {
        type: 'number',
        section: 'income_statement',
        label: 'Interest Income'
    },
    interestExpense: {
        type: 'number',
        section: 'income_statement',
        label: 'Interest Expense'
    },
    otherIncome: {
        type: 'number',
        section: 'income_statement',
        label: 'Other Income'
    },
    incomeTax: {
        type: 'number',
        section: 'income_statement',
        label: 'Income Tax'
    },
    cash: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Cash'
    },
    receivables: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Receivables'
    },
    inventory: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Inventory'
    },
    otherCurrentAssets: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Other Current Assets'
    },
    grossFixedAssets: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Gross Fixed Assets'
    },
    accumDepreciationAmortizationDepltn: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Accum. Depreciation-Amortization-Depltn'
    },
    netFixedAssets: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Net Fixed Assets'
    },
    otherNonCurrentAssets: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Other Non-Current Assets'
    },

    accountsPayable: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Accounts Payable'
    },
    loansNotesPayable: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Loans/Notes Payable'
    },
    otherCurrentLiabilities: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Other Current Liabilities'
    },
    totalLongTermLiabilities: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Total Long Term Liabilities'
    },
    employment: {
        type: 'number',
        section: 'employment',
        label: 'Employment'
    },
    averageAnnualWage: {
        type: 'number',
        section: 'employment',
        label: 'Average Annual Wage'
    },
};

const companyReportInputs = {
    annualSales: {
        type: 'number',
        section: 'income_statement',
        label: 'Business Revenue*'
    },
    grossMargin: {
        type: 'number',
        section: 'income_statement',
        label: 'Gross Margin*'
    },
    officersComp: {
        type: 'number',
        section: 'income_statement',
        label: 'Officers Compensation'
    },
    depreciation: {
        type: 'number',
        section: 'income_statement',
        label: 'Depreciation'
    },
    operatingExpenses: {
        type: 'number',
        section: 'income_statement',
        label: 'Operating Expenses'
    },
    preTaxNetProfit: {
        type: 'number',
        section: 'income_statement',
        label: 'Pre-tax Net Profit'
    },
    interestExpense: {
        type: 'number',
        section: 'income_statement',
        label: 'Interest Expense'
    },
    accountsReceivable: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Accounts Receivable'
    },
    currentAssets: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Current Assets'
    },
    totalAssets: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Total Assets'
    },
    accountsPayable: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Accounts Payable'
    },
    otherCurrentLiabilities: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Total Current Liabilities'
    },
    totalLongTermLiabilities: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Total Long Term Liabilities'
    },
    employment: {
        type: 'number',
        section: 'employment',
        label: 'Employment'
    },
    averageAnnualWage: {
        type: 'number',
        section: 'employment',
        label: 'Average Annual Wage'
    },
};
const valuationReportInputs = {
    businessRevenue: {
        type: 'number',
        section: 'income_statement',
        label: 'Business Revenue*'
    },
    grossMargin: {
        type: 'number',
        section: 'income_statement',
        label: 'Gross Margin*'
    },
    officersComp: {
        type: 'number',
        section: 'income_statement',
        label: 'Officers Compensation'
    },
    preTaxNetProfit: {
        type: 'number',
        section: 'income_statement',
        label: 'Pre-tax Net Profit'
    },
    //1x Expense Addbacks
    //Owner Replacement Compensation
    depreciationOtherNonCashExpenses: {
        type: 'number',
        section: 'income_statement',
        label: 'Depreciation-Other Non-Cash Expense'
    },
    operatingExpenses: {
        type: 'number',
        section: 'income_statement',
        label: 'Operating Expenses'
    },
    interestExpense: {
        type: 'number',
        section: 'income_statement',
        label: 'Interest Expense'
    },
    accountsReceivable: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Accounts Receivable'
    },
    totalCurrentAssets: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Total Current Assets'
    },
    totalAssets: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Total Assets'
    },
    accountsPayable: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Accounts Payable'
    },
    otherCurrentLiabilities: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Total Current Liabilities'
    },
    totalLongTermLiabilities: {
        type: 'number',
        section: 'balance_sheet',
        label: 'Total Long Term Liabilities'
    },
    employment: {
        type: 'number',
        section: 'employment',
        label: 'Employment'
    },
    averageAnnualWage: {
        type: 'number',
        section: 'employment',
        label: 'Average Annual Wage'
    },
};

export default {
    reportType,
    marketReportInputs,
    financialReportInputs,
    companyReportInputs,
    valuationReportInputs
};